"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryClient = void 0;
const react_query_1 = require("@tanstack/react-query");
exports.useQueryClient = react_query_1.useQueryClient;
